var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ipub-button",class:[
          _vm.type ? 'ipub-button--' + _vm.type : '',
          _vm.size ? 'ipub-button--' + _vm.size : '',
          {
            'is-disabled': _vm.disabled,
            'is-plain': _vm.plain,
            'is-round': _vm.round,
            'is-circle': _vm.circle,
            'is-loading': _vm.loading,
          }
        ],on:{"click":_vm.handleClick}},[(!_vm.icon&&_vm.loading)?_c('ipub-icon',{staticStyle:{"margin-right":"10px"},attrs:{"type":"loading"}}):_vm._e(),(_vm.icon)?_c('ipub-icon',{staticClass:"ipub-button__icon",attrs:{"type":_vm.icon}}):_vm._e(),(!_vm.circle)?[_vm._t("default")]:_vm._e(),(_vm.icon&&_vm.loading)?_c('ipub-icon',{staticStyle:{"margin-left":"10px"},attrs:{"type":"loading"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }